import React, { useState, useEffect } from "react";
import styled from "styled-components";
import WelcomeItem from "./welcome-item";
import WelcomeModal from "./welcome-modal";
import { useMediaQuery } from "@mui/material";
import PageHeader from "../../common/PageHeader";

import "./style.scss";
import useDidMountEffect from "../../utils/useDidMountEffect";
import { Spinner } from "react-bootstrap";
import { ReactSortable } from "react-sortablejs";
import { ROLES } from "../../utils/constants";
import { useDispatch } from "react-redux";
import { setSettings } from "../../../redux/actions";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import DefaultPUWidget from "../../Widgets/PU/Default";
import DefaultWidget from "../../Widgets/SU/Default";
import useRedirectIfNoData from "../../utils/useRedirectIfNoData";

const WelcomeMessages = () => {
    const isMobile = useMediaQuery("(max-width: 899px)");
    const dispatch = useDispatch();

    const [welcomeMessages, setWelcomeMessages] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [activeWelcome, setActiveWelcome] = useState({});
    const [fetch, setFetch] = useState(0);
    const [busy, setBusy] = useState(false);
    const [isSorted, setIsSorted] = useState(false);
    const [isUpdated, setIsUpdated] = useState(false);

    const userInformation = JSON.parse(localStorage.getItem("user"));

    useEffect(() => {
        if (
            !userInformation ||
            ![ROLES.PU, ROLES.ADMIN].includes(userInformation.role)
        ) {
            window.location = "/";
        }

        const params = {
            only: "min_ppv_price,max_ppv_price",
        };

        dispatch(setSettings(params));
    }, []);

    const getWelcomeMessages = async () => {
        setBusy(true);
        await axios
            .get("/api/welcome-messages")
            .then((response) => {
                setBusy(false);
                setWelcomeMessages(response.data.data);
            })
            .catch((error) => {
                setBusy(false);
            });
    };
    // const updateWelcomeMessagesFeatureAlert = async () => {
    //     setBusy(true);
    //     await axios.post('/api/alerts/update-welcome-messages')
    //         .then(response => {
    //             const userInformation = JSON.parse(localStorage.getItem('user'));
    //             localStorage.setItem('user', JSON.stringify(userInformation.alerts[0].welcome_message.value(true)));
    //             console.log(response.data, userInformation);
    //             setBusy(false);
    //         })
    //         .catch(error => {
    //             setBusy(false);
    //         });
    // };

    useDidMountEffect(() => {
        let mounted = true;

        return () => {
            mounted = false;
        };
    }, []);

    const handleNewMessage = () => {
        setShowForm(true);
    };

    useEffect(() => {
        // updateWelcomeMessagesFeatureAlert();
        getWelcomeMessages();
    }, [fetch]);

    const handleSort = (newState) => {
        const ranked = newState.map((state, index) => {
            return {
                ...state,
                order: index + 1,
            };
        });

        setWelcomeMessages(ranked);
    };

    const handleChange = (evt) => {
        setIsSorted(true);
    };

    const updateWelcomeMessages = async () => {
        setBusy(true);
        const payload = welcomeMessages.map((welcomeMessage) => {
            return {
                id: welcomeMessage.id,
                order: welcomeMessage.order,
            };
        });

        await axios
            .patch("/api/welcome-messages", {
                payload,
            })
            .then((response) => {
                console.log(response);
                setIsSorted(false);
                setIsUpdated(false);
                setBusy(false);
            })
            .catch((error) => {
                console.error({ error });
                setBusy(false);
            });
    };

    useEffect(() => {
        let mounted = true;

        if (isSorted) {
            updateWelcomeMessages();
        }

        return () => {
            mounted = false;
        };
    }, [isSorted]);

    useDidMountEffect(() => {
        if (activeWelcome && Object.keys(activeWelcome).length > 0) {
            setShowForm(true);
        }
    }, [activeWelcome]);

    return (
        <div className="container">
            <Grid2 container spacing={!isMobile ? 2 : 0}>
                <Grid2 md={8}>
                    <div className="welcome-messages">
                        <PageHeader title="Welcome Messages" />

                        <div className="welcome-message__container">
                            <button
                                className="btn btn-primary btn-rounded"
                                onClick={handleNewMessage}
                                style={{
                                    textTransform: "none",
                                    marginTop: "12px",
                                }}
                            >
                                <i className="fa-regular fa-plus"></i> New
                                Welcome Message
                            </button>

                            <div className="my-5">
                                {busy && (
                                    <div className="my-2 text-center">
                                        <Spinner
                                            animation="border"
                                            variant="primary"
                                            size="sm"
                                        />
                                    </div>
                                )}
                                <ReactSortable
                                    list={welcomeMessages}
                                    setList={(newState) => handleSort(newState)}
                                    onSort={handleChange}
                                    direction="vertical"
                                    handle=".drag-handler"
                                    swap
                                >
                                    {welcomeMessages &&
                                        welcomeMessages.length > 0 &&
                                        welcomeMessages.map((welcome) => {
                                            return (
                                                <WelcomeItem
                                                    key={welcome.id}
                                                    welcome={welcome}
                                                    setFetch={setFetch}
                                                    fetch={fetch}
                                                    setActiveWelcome={
                                                        setActiveWelcome
                                                    }
                                                />
                                            );
                                        })}
                                </ReactSortable>

                                {!busy &&
                                    (!welcomeMessages ||
                                        welcomeMessages.length <= 0) && (
                                        <div className="py-2 text-center">
                                            No welcome message found
                                        </div>
                                    )}
                            </div>
                        </div>

                        {showForm && (
                            <WelcomeModal
                                show={showForm}
                                setShow={setShowForm}
                                activeWelcome={activeWelcome}
                                setFetch={setFetch}
                                fetch={fetch}
                                setActiveWelcome={setActiveWelcome}
                            />
                        )}
                    </div>
                </Grid2>
                {!isMobile ? (
                    <Grid2 className="pu-homepage__right" md={4}>
                        {userInformation && userInformation.role == ROLES.PU ? (
                            <DefaultPUWidget />
                        ) : null}
                        {userInformation && userInformation.role == ROLES.SU ? (
                            <DefaultWidget />
                        ) : null}
                    </Grid2>
                ) : null}
            </Grid2>
        </div>
    );
};

export default React.memo(WelcomeMessages);
